import { EnrollEventFormDefaultValues } from '../interfaces';

export const enrollFormFieldKeys: Record<keyof EnrollEventFormDefaultValues, string> = {
  supervisorName: 'supervisor_data|Imię',
  supervisorSurname: 'supervisor_data|Nazwisko',
  supervisorEmail: 'supervisor_data|Adres e-mail',
  phone: 'own_contact_data|Telefon',
  accommodation: 'details|Zarezerwuj nocleg',
  vegeFood: 'details|Wybierz posiłek - wegetariański',
  parking: 'details|Zarezerwuj miejsce parkingowe',
  dinner: 'details|Zarezerwuj kolację',
};
